import React, { Component } from 'react';
import PropTypes from 'prop-types';
import set from 'lodash.set';
import { Input, Button, TextArea } from '@surfline/quiver-react';
import config from '../../config';

class GiftCardMessageForm extends Component {
  render() {
    const {
      action,
      selectedProductId,
      savedGiftData,
    } = this.props;
    return (
      <div>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            action([...new FormData(event.target)].reduce((formFields, [field, value]) => {
              set(formFields, field, value);
              return formFields;
            }, {}));
          }}
          className="gift-card-message-form"
        >
          <input type="hidden" name="giftProductId" value={selectedProductId} />
          <div className="gift-card-message-form__label">TO:</div>
          <div className="gift-card-recipient">
            <Input
              defaultValue={savedGiftData.recipientName}
              label="RECIPIENT NAME"
              id="recipientName"
              type="text"
              input={{ name: 'recipientName' }}
            />
            <Input
              defaultValue={savedGiftData.recipientEmail}
              label="RECIPIENT EMAIL"
              id="recipientEmail"
              type="email"
              input={{ name: 'recipientEmail' }}
            />
          </div>
          <div className="gift-card-message-form__label">FROM:</div>
          <div className="gift-card-sender">
            <Input
              defaultValue={savedGiftData.purchaserName}
              label="SENDER NAME"
              id="purchaserName"
              type="text"
              input={{ name: 'purchaserName', required: true }}
            />
            <Input
              defaultValue={savedGiftData.purchaserEmail}
              label="SENDER EMAIL"
              id="purchaserEmail"
              type="email"
              input={{ name: 'purchaserEmail', required: true }}
            />
          </div>
          <div className="gift-card-message-form__label">MESSAGE:</div>
          <div className="gift-card-message">
            <TextArea
              defaultValue={savedGiftData.message}
              label="OPTIONAL(UP TO 140 CHARACTERS)"
              textarea={{ name: 'message', maxLength: 140 }}
            />
          </div>
          <Button label="Continue">CONTINUE</Button>
          <a href={config.giftPurchaseHelpUrl} className="gift-card-learn-more">Learn more about gift cards.</a>
        </form>

      </div>
    );
  }
}

GiftCardMessageForm.propTypes = {
  action: PropTypes.func.isRequired,
  selectedProductId: PropTypes.string.isRequired,
  savedGiftData: PropTypes.shape({})
};
GiftCardMessageForm.defaultProps = {
  savedGiftData: {}
};

export default GiftCardMessageForm;
